import { ButtonIconAction } from 'components/button/ButtonIconAction';
import { Typography } from 'enable-ui';

export const getAdminsColumns = (
  onClickAction: (key: 'edit' | 'delete' | 'update-status', id: string) => void,
  isSuperAdmin: boolean,
) => {
  return [
    {
      id: 'name',
      Header: 'Name',
      width: '50%',
      minWidth: '50%',
      sort: true,
      sortType: 'name',
      Cell: ({ ...props }) => {
        const name = props.data[props.row.index]?.name || '';

        return <Typography>{name}</Typography>;
      },
    },

    {
      id: 'email',
      Header: 'Email',
      width: '50%',
      minWidth: '50%',
      Cell: ({ ...props }) => {
        const email = props.data[props.row.index]?.email || '';

        return <Typography>{email}</Typography>;
      },
    },

    // {
    //   id: 'status',
    //   Header: 'Status',
    //   width: '124px',
    //   minWidth: '124px',
    //   sort: true,
    //   sortType: 'status',
    //   Cell: ({ ...props }) => {
    //     const isActive = props.data[props.row.index]?.isActive;

    //     return (
    //       <Tag
    //         color={isActive ? 'green' : 'red'}
    //         dot
    //         style={{ fontWeight: 600, fontSize: 16, borderRadius: '12px', padding: '3px 8px' }}
    //       >
    //         {isActive ? 'Active' : 'Inactive'}
    //       </Tag>
    //     );
    //   },
    // },

    {
      id: 'action',
      Header: '',
      width: '40px',
      minWidth: '40px',
      sort: false,
      sortType: 'action',
      Cell: ({ ...props }) => {
        const isActive = props.data[props.row.index]?.isActive;

        const adminId = props.data[props.row.index]?.id;
        const isRowSuperAdmin = props.data[props.row.index]?.isSuperAdmin;

        if (!isSuperAdmin) return null;

        let actions = [
          {
            label: 'Edit',
            onClick: () => onClickAction('edit', adminId),
          },
        ];

        if (!isRowSuperAdmin) {
          actions = actions.concat([
            {
              label: 'Delete',
              onClick: () => onClickAction('delete', adminId),
            },
            // isActive
            //   ? {
            //       label: 'Inactivate',
            //       onClick: () => onClickAction('update-status', adminId),
            //     }
            //   : {
            //       label: 'Activate',
            //       onClick: () => onClickAction('update-status', adminId),
            //     },
          ]);
        }

        return <ButtonIconAction actions={actions} />;
      },
    },
  ];
};
